<template>
    <div>
        <el-form ref="form" :model="form" label-width="150px">
          <el-form-item label="姓名">
              <el-select v-model="form.userid" disabled >
                <el-option :label="form.name" :value="form.userid">
              </el-option>
              </el-select>
          </el-form-item>
          <el-form-item :label="form.type==1?'佣金(单位:元/盒)':'佣金率(0.35表示35%)'" placeholder="请输入分销商佣金">
            <el-input v-model="form.commission" ></el-input>
          </el-form-item>
          <el-form-item label="绑定药品" v-if="form.type==1">
            <el-select v-model="form.drugid"  filterable placeholder="请选择药品">
              <el-option
                v-for="item in druglist"
                :key="item.id"
                :label="item.drugname"  
                :value="item.id">
                <span style="float: left">{{ item.drugname }}</span>
                <span style="float: left">|{{ item.drugspec }}</span>
                <span style="float: left">|{{ item.drugfactory }}</span>
                <span style="float: left">|{{ item.drugsalecorp }}</span>
                <span style="float: left">|商品码{{ item.drugcode }}</span>
                <span style="float: left">|站点:{{ item.drugterminal }}</span>
              </el-option>
            </el-select>
         </el-form-item>
         <el-form-item label="绑定医院" >
            <el-select v-model="form.drughospital"  filterable  placeholder="请选择医院">
              <el-option
                v-for="item in hospitallist"
                :key="item.id"
                :label="item.name"  
                :value="item.name">
              </el-option>
            </el-select>
         </el-form-item>
         <el-form-item label="合作期限" >
          <el-date-picker
            v-model="form.startDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"	
            placeholder="开始时间">
          </el-date-picker>
          <el-date-picker
            v-model="form.endDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"	
            placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSaveAdd">添加佣金配置</el-button>
            <el-button type="default" @click="goBack">返回</el-button>
          </el-form-item>
        </el-form>


        <el-divider>【{{ form.name }}】佣金配置列表</el-divider>
        <el-table
          :data="usercommissionlist"
          style="width: 100%">
          <el-table-column
            label="姓名"
            prop="name">
          </el-table-column>
          <el-table-column
            label="类型"
            prop="typename">
          </el-table-column>
          <el-table-column
            label="佣金"
            prop="commissionstr"
          >
          </el-table-column>
          <el-table-column
            label="绑定医院"
            prop="drughospital"
          >
          </el-table-column>
          <el-table-column
            label="绑定药品"
            prop="druginfo"
          >
          </el-table-column>
          <el-table-column
            align="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row.id,scope.row.userid)">修改</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="修改用户佣金配置" :visible.sync="userComEditDiagShow">
                <el-form ref="formEdit" :model="formEdit" label-width="80px">
                <el-form-item label="姓名">
                    <el-select v-model="formEdit.userid" disabled >
                      <el-option :label="formEdit.name" :value="formEdit.userid">
                    </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="formEdit.type==1?'佣金(单位:元/盒)':'佣金率'" placeholder="请输入分销商佣金">
                  <el-input v-model="formEdit.commission" ></el-input>
                </el-form-item>
                <el-form-item label="绑定药品" v-if="formEdit.type==1">
                  <el-select v-model="formEdit.drugid"  filterable placeholder="请选择药品">
                    <el-option
                      v-for="item in druglist"
                      :key="item.id"
                      :label="item.drugname"  
                      :value="item.id">
                      <span style="float: left">{{ item.drugname }}</span>
                      <span style="float: left">|{{ item.drugspec }}</span>
                      <span style="float: left">|{{ item.drugfactory }}</span>
                      <span style="float: left">|{{ item.drugsalecorp }}</span>
                      <span style="float: left">|商品码{{ item.drugcode }}</span>
                      <span style="float: left">|站点:{{ item.drugterminal }}</span>

                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="绑定医院" >
                  <el-select v-model="formEdit.drughospital"  filterable  placeholder="请选择医院">
                    <el-option
                      v-for="item in hospitallist"
                      :key="item.id"
                      :label="item.name"  
                      :value="item.name">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="合作期限" >
                <el-date-picker
                  v-model="formEdit.startDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"	
                  placeholder="开始时间">
                </el-date-picker>
                <el-date-picker
                  v-model="formEdit.endDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"	
                  placeholder="结束时间">
                </el-date-picker>
              </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSaveModify">确认修改</el-button>
                  <el-button type="default" @click="userComEditDiagShow=false">取消</el-button>
                </el-form-item>
              </el-form>
        </el-dialog>

    </div>  
</template>
<script>
  export default {
    data() {
      return {
        form:{
          userid:'',
          type:'',
          name:'',
          commission: '',
          drugid:'',
          drughospital:'',
          startDate:'',
          endDate:''
        },
        processing:false,
        usercommissionlist:[],
        userComEditDiagShow:false,
        formEdit:{
          id:'',
          userid:'',
          type:'',
          name:'',
          commission: '',
          drugid:'',
          drughospital:'',
          startDate:'',
          endDate:''
        },
        druglist:[],
        hospitallist:[]
      }
    },
    created(){
          if(this.$route.query.userid==undefined||isNaN(this.$route.query.userid)){
              this.$message.error("参数错误");
              setTimeout(()=>{this.$go("/addUser")},500)
          }
          this.form.userid=this.$route.query.userid
          this.initUserCommissionAdd(this.form.userid)
    },
    methods: {
      initUserCommissionAdd(id){
          this.$post("/UserCommission/initAddUserCommission",{id:id}).then((data)=>{
              if(data.result.success){
                 this.usercommissionlist=data.result.info.list
                 this.form.userid=data.result.info.user.userid
                 this.form.type=data.result.info.user.type
                 this.form.name=data.result.info.user.name
                 this.druglist=data.result.info.druglist
                 this.hospitallist=data.result.info.hospitallist
              }
          })
      },
      onSaveAdd() {
          if(this.processing){
             this.$message.error("请等待处理完成");return false
          }
          if(this.form.userid==''){
            this.$message.error("内部参数有误");return false
          }
          
          if(this.form.commission==''||isNaN(this.form.commission)||parseInt(this.form.commission)<0){
            this.$message.error("佣金值设置非法");return false
          }
          if(this.form.type==1){
             if(this.form.drugid==""||this.form.drugid==undefined){
                 this.$message.error("请选择绑定药品");return false
             }
          }else if(this.form.type==2){
             this.form.drugid=0
             if(this.form.commission>=1){
                this.$message.error("有效值范围为0~1");return false
             }
          }
          
          if(this.form.drughospital =='' || this.form.drughospital == undefined){
            this.$message.error("请选择绑定医院");return false
          }
  
        
          this.processing=true
          this.$post("/Usercommission/addUserCommission",{commissioninfo:this.form}).then((data)=>{
               this.processing=false
               if(data.result.success){
                   this.$message({message:data.result.info,type:'success'})
                   this.initUserCommissionAdd(this.form.userid)
               }else{
                   this.$message.error(data.result.info)
               }
          })
      },
      handleEdit(id) {
          this.initUserCommissionModify(id)
      },
      initUserCommissionModify(id){
          this.$post("/UserCommission/initUserCommissionModify",{id:id}).then((data)=>{
              if(data.result.success){
                 this.druglist=data.result.info.druglist
                 this.hospitallist=data.result.info.hospitallist
                 this.formEdit=data.result.info.formedit
                 this.userComEditDiagShow=true
              }
          })
      },
      onSaveModify(){
          if(this.processing){
             this.$message.error("请等待处理完成");return false
          }
          if(this.formEdit.id==""){
            this.$message.error("内部参数有误");return false
          }
          if(this.formEdit.userid==''){
            this.$message.error("内部参数有误");return false
          }
          
          if(this.formEdit.commission==''||isNaN(this.formEdit.commission)||parseInt(this.formEdit.commission)<0){
            this.$message.error("佣金值设置非法");return false
          }
          if(this.formEdit.type==1){
             if(this.formEdit.drugid==""||this.formEdit.drugid==undefined){
                 this.$message.error("请选择绑定药品");return false
             }
          }else if(this.formEdit.type==2){
             this.formEdit.drugid=0
             if(this.formEdit.commission>=1){
                this.$message.error("有效值范围为0~1");return false
             }
          }

          if(this.formEdit.drughospital==''){
            this.$message.error("请选择绑定医院");return false
          }
  
          this.processing=true
          this.$post("/UserCommission/saveUserCommissionModify",{commissioninfo:this.formEdit}).then((data)=>{
              this.processing=false
              if(data.result.success){
                 this.$message({message:"操作成功",type:'success'})
                 this.updateComList(data.result.info)
                 this.userComEditDiagShow=false
              }else{
                 this.$message({message:data.result.info,type:'error'})
              }
          })
      },
      handleDelete(id) {
        this.$confirm('此操作将删除用户该条佣金配置记录，如已导出奖励，请重新计算下载生成, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.doDelete(id)
        }).catch(() => {
                     
        });        
      },
      doDelete(id){
        this.processing=true
        this.$post("/UserCommission/delUserCommission",{id:id}).then((data)=>{
              this.processing=false
              if(data.result.success){
                 this.$message({message:"操作成功",type:'success'})
                 this.updateComList(data.result.info)
              }else{
                 this.$message({message:data.result.info,type:'error'})
              }
          })
      },
      updateComList(userid){
          this.$post("/UserCommission/updateComlist",{userid:userid}).then((data)=>{
              if(data.result.success){
                 this.usercommissionlist=data.result.info
              }else{
                 this.$message({message:data.result.info,type:'error'})
              }
          })
      },
      goBack(){
          this.$go("/addUser")
      }
    }
  }
</script>

<style scoped lang="scss">
/deep/ .el-divider--horizontal {
  margin-top:50px!important;
}
</style>
